/**
 * Alert/Toast Component
 */

import React from 'react';
import { Alert as AlertType } from 'common';
import '@components/common/Alert.css';

interface AlertProps {
  alert: AlertType;
  onClose: () => void;
}

const Alert: React.FC<AlertProps> = ({ alert, onClose }) => {
  React.useEffect(() => {
    const timer = setTimeout(onClose, 5000); // Auto-close after 5 seconds
    return () => clearTimeout(timer);
  }, [onClose]);

  const alertClass = `alert alert--${alert.level}`;

  return (
    <div className={alertClass}>
      <div className="alert__content">
        <p className="alert__message">{alert.message}</p>
      </div>
      <button className="alert__close" onClick={onClose}>
        ?
      </button>
    </div>
  );
};

export default Alert;
